// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1u5vF","actionsCol":"EnrolledClinics_actionsCol__3V1cM"};